import { configureStore } from "@reduxjs/toolkit";
import recordingReducer from "./slices/recording.slice";
import { firebaseApiWrapper } from "./api/firebaseApiWrapper.rtkq";
import { backendApi } from "./api/backendApi.rtkq";
import { conversationsApi } from "./api/conversations_new.rtkq";
import { slackApi } from "./api/slack.rtkq";
import "./api/speakerIdentification.rtkq";
import sentryReduxMiddleware from "./sentryMiddleware";

export const store = configureStore({
  reducer: {
    [firebaseApiWrapper.reducerPath]: firebaseApiWrapper.reducer, // kept for documents (still on Firestore)
    [backendApi.reducerPath]: backendApi.reducer,
    [conversationsApi.reducerPath]: conversationsApi.reducer,
    [slackApi.reducerPath]: slackApi.reducer,
    recording: recordingReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      sentryReduxMiddleware, // Add Sentry middleware first for better tracking
      firebaseApiWrapper.middleware, // kept for documents
      backendApi.middleware,
      conversationsApi.middleware,
      slackApi.middleware,
    ),
  devTools: true,
});
